import { render } from "./MeetingFormatManagement.vue?vue&type=template&id=83bd8a3c&scoped=true"
import script from "./MeetingFormatManagement.vue?vue&type=script&lang=js"
export * from "./MeetingFormatManagement.vue?vue&type=script&lang=js"

import "./MeetingFormatManagement.vue?vue&type=style&index=0&id=83bd8a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83bd8a3c"]])

export default __exports__